{
  "feeCalculator": {
    "sections": {
      "inputs": "Inputs",
      "calculations": "Calculations"
    },
    "tabs": {
      "tenantAndTransient": "Tenant & Transient Fees",
      "annualFees": "Annual Fees"
    },
    "rateLabels": {
      "default": "Default"
    },
    "inputs": {
      "aircraft": {
        "title": "Aircraft",
        "subtitle": "Aircraft you would like to calculate fees for. We'll use the wingspan and length to calculate the area to use in calculations.",
        "makeModel": "Make/Model",
        "dimensions": "Dimensions"
      },
      "buffer": {
        "title": "Buffer",
        "subtitle": "A buffer is added to each end of the dimensions. Eg: a 2{{unit}} buffer adds a total of 4{{unit}} to the length and 4{{unit}} to the wingspan."
      },
      "baseTenantRate": {
        "title": "Base Tenant Rate",
        "subtitle": "Rate to use for calculating monthly tenant pricing.",
        "label": "$ / sq{{unit}} / month"
      },
      "transientRate": {
        "title": "Transient Rate",
        "subtitle": "Rate to use for calculating nightly transient pricing.",
        "label": "$ / sq{{unit}} / day"
      },
      "presets": {
        "title": "Presets",
        "subtitle": "You can add/edit preset rates in Settings > Estimation.",
        "label": "Rates"
      },
      "camFees": {
        "title": "Common Area Maintenance Fees",
        "subtitle": "Common Area Maintenance Fees added to monthly tenant rate. You can specify a percentage fee or a {{unit}}² fee.",
        "or": "OR"
      }
    },
    "calculations": {
      "aircraftSquare": "Aircraft Square {{unit}}",
      "aircraftSquareSubtitle": "Area taken up by the aircraft. Measured as wingspan x length.",
      "totalSquare": "Total Square {{unit}}",
      "totalSquareSubtitle": "Area taken up by the aircraft + buffer (if provided).",
      "aircraftFee": "Aircraft Fee",
      "camFees": "CAM Fees",
      "totalFee": "Total Fee",
      "tenantMonthly": "Tenant (monthly)",
      "transientDaily": "Transient (daily)"
    }
  }
}
